/**
 * Help-center URLs surfaced via HelpLink.
 *
 * TODO(LR-316): the URLs below are placeholders. Replace each value with
 * the published Confluence page link before this branch ships. The keys
 * are stable — call sites refer to them symbolically (`<HelpLink to="..."/>`)
 * so URL churn here is one edit per surface and does not touch consumers.
 *
 * To add a new surface: add a key here, write the doc, replace the URL
 * with the published page link.
 */

export const DOCS_BASE_URL = 'https://exantech.atlassian.net/wiki/spaces/LR';

// TODO(LR-316): docs URLs are intentionally empty placeholders until the
// Confluence pages are published. Empty values cause `HelpLink` to render
// `null` silently — wiring is in place, no UI surface exposed yet. To
// re-enable: replace each '' with the published page URL. Keys are stable;
// call sites (tour-steps, page headers) refer to them symbolically.
export const DOCS_LINKS = {
  // inventory, trades, counterpartyReports, counterparties, markToMarket и
  // tradeHistory ссылаются на mkdocs-документацию
  // (отдаётся под /docs/ тем же nginx, что и фронт), а не на Confluence —
  // страницы уже опубликованы в `documentation/`. Относительный путь
  // работает только на стендах, где /docs/ обслуживается: на проде
  // host-nginx отдаёт 404 by design, поэтому HelpLink гейтит внутренние
  // ссылки серверным флагом `docs_enabled` (LR-593). Остальные ключи
  // остаются заглушками до публикации Confluence-страниц (LR-316).
  inventory: '/docs/product/knowledge_base/inventory/overview/',
  trades: '/docs/product/knowledge_base/trades/overview/',
  counterpartyReports: '/docs/product/knowledge_base/inventory/counterparty_reports/',
  counterparties: '/docs/product/knowledge_base/registers/overview/',
  savedViews: '', // `${DOCS_BASE_URL}/pages/saved-views`
  markToMarket: '/docs/product/knowledge_base/collateral/overview/',
  tradeHistory: '/docs/product/knowledge_base/trades/history/',
  singleTrade: '', // `${DOCS_BASE_URL}/pages/single-trade`
} as const;

export type DocsLinkKey = keyof typeof DOCS_LINKS;

export const isDocsLinkKey = (value: string): value is DocsLinkKey =>
  Object.prototype.hasOwnProperty.call(DOCS_LINKS, value);
